<!--
 * @Author:
 * @LastEditTime: 2023-07-28
 * @Description: 危险源辨别计划
-->
<template>
  <el-card class="h-full">
    <div class="h-full flex flex-col" v-if="currentComp === 'TABLE'">
      <div class="flex mb-10px flex-wrap">
        <el-input
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请输入关键字"
          v-model="searchData.keywords"
          clearable
        ></el-input>
        <el-select
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择计划状态"
          v-model="searchData.publishStatus"
          clearable
        >
          <el-option
            v-for="item in planStatusList"
            :key="item.code"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择辨识类型"
          v-model="searchData.analyzeEvaluationType"
          clearable
        >
          <el-option
            v-for="item in identifyTypeList"
            :key="item.code"
            :label="item.displayName"
            :value="item.code"
          ></el-option>
        </el-select>
        <el-button class="mb-10px" size="small" type="primary" @click="handleSearch()"
          >搜索</el-button
        >
        <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
        <el-button
          class="mb-10px"
          size="small"
          type="primary"
          @click="handleEvent(null, 'create')"
          :disabled="!$hasAccess('create')"
          >新增</el-button
        >
      </div>
      <div class="flex-auto h-0px">
        <el-table
          :data="dataList"
          border
          class="w-full"
          :height="tableHeight"
          stripe
          v-loading="tableLoading"
          @selection-change="handleSelection"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="辨识评价计划名称"
            prop="recognitionPlanName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="分析评价类型" prop="analyzeEvaluationType" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.analyzeEvaluationType === 1">设备设施类</span>
              <span v-if="scope.row.analyzeEvaluationType === 0">作业清单类</span>
            </template>
          </el-table-column>
          <el-table-column label="计划开始时间" prop="planTimeStart" show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.planTimeStart
                  ? dayjs(scope.row.planTimeStart).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column label="计划结束时间" prop="planTimeEnd" show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.planTimeEnd
                  ? dayjs(scope.row.planTimeEnd).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="计划管控负责人"
            prop="planHeadControlName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="辨识状态" prop="publishStatus" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag size="mini" :type="planStatusTypes(scope.row.publishStatus)">{{
                planStatusMap(scope.row.publishStatus)
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="300">
            <template slot-scope="scope">
              <table-operate-button :key="scope.row.id" :buttons="buttons(scope.row)" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="tableSizeChange"
          @current-change="tableCurrentChange"
          :current-page.sync="pageConfig.SkipCount"
          :page-size.sync="pageConfig.MaxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="totalCount"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>
    <risk-identify-form
      v-if="currentComp === 'CREATE' || currentComp === 'UPDATE' || currentComp === 'READ'"
      :FormData="FormData"
      @refreshList="refreshList"
      @cancel="handleCancel"
      :formProps="formProps"
    ></risk-identify-form>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import {
  SourcesDangerRecognitionPlanApi,
  SourcesDangerRecognitionPlanTaskApi,
} from '@wiz-api/double-prevention-management'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import { planStatusTypes } from '@/components/safety/enumField/enumTypeMethods'
import utils from '@/components/safety/enumField/utils'
import RiskIdentifyForm from '../components/RiskIdentifyForm'

const sourcesDangerRecognitionPlanTaskApi = new SourcesDangerRecognitionPlanTaskApi()
const sourcesDangerRecognitionPlanApi = new SourcesDangerRecognitionPlanApi()
export default {
  name: 'risk-identify-plan',
  components: {
    TableOperateButton,
    RiskIdentifyForm,
  },
  data() {
    return {
      currentComp: 'TABLE',
      FormData: {
        recognitionPlanName: '',
        recognitionPlanTopic: '',
        planHeadControlId: '',
        analyzeEvaluationType: 1,
        publishStatus: 0,
        dateArr: [],
        sourcesDangerRecognitionPlanTaskDtos: [],
        planTimeStart: '',
        planTimeEnd: '',
      },
      formDialog: false,
      formProps: {
        // create 新增 update 编辑 read 详情
        pageType: 'create',
      },
      departmentList: [],
      planStatusList: [],
      identifyTypeList: [
        {
          code: 1,
          displayName: '设备设施类',
        },
        {
          code: 0,
          displayName: '作业清单类',
        },
      ],
      // 设备设施清单
      dataList: [],
      tableLoading: false,
      totalCount: 0,
      searchData: {
        analyzeEvaluationType: '',
        publishStatus: '',
        keywords: '',
      },
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionData: [],
    }
  },
  created() {
    // 获取字典
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.RiskIdentifyPlanStatus'],
      ['planStatusList'],
      this
    )
    this.getList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    planStatusTypes() {
      return (val) => {
        return planStatusTypes(val)
      }
    },
    planStatusMap() {
      return (val) => {
        return (
          this.planStatusList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    buttons() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read') && val.publishStatus !== 0,
          },
          {
            text: '编辑',
            click: () => {
              return this.handleEvent(val, 'update')
            },
            isShow: this.$hasAccess('update') && val.publishStatus === 0,
          },
          {
            text: '删除',
            click: () => {
              return this.handleEvent(val, 'delete')
            },
            isShow: this.$hasAccess('delete') && [0, 2].includes(val.publishStatus),
          },
          {
            text: '发布',
            click: () => {
              return this.handleEvent(val, 'publish')
            },
            isShow: this.$hasAccess('publish') && val.publishStatus === 0,
          },
          {
            text: '重新发布',
            click: () => {
              return this.handleEvent(val, 'refreshPublish')
            },
            isShow: this.$hasAccess('refreshPublish') && val.publishStatus === 2,
          },
        ]
      }
    },
  },
  methods: {
    /**
     * 重置
     */
    resetText() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    /**
     * 刷新列表
     */
    refreshList() {
      this.checkComp('TABLE')
      this.getList()
    },

    /**
     *
     * 返回
     */
    handleCancel() {
      this.checkComp('TABLE')
    },
    // 判断当前辨识计划是否已逾期
    planIsOverdue(endDate) {
      let overdue = false
      const nowDateString = dayjs().unix()
      const endDateString = dayjs(endDate).unix()
      if (nowDateString > endDateString) {
        // 已逾期
        overdue = true
      }
      return overdue
    },
    // 切换组件
    checkComp(name) {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = name
      })
    },
    // 列表操作-事件
    async handleEvent(row = null, operation) {
      if (['update', 'publish'].includes(operation) && this.planIsOverdue(row.planTimeEnd)) {
        this.$message.warning('辨识计划已逾期,无法进行操作')
        return
      }
      let err = null
      let res = null
      switch (operation) {
        case 'create':
          this.FormData = this.$options.data().FormData
          this.initDialog(operation)
          break
        case 'delete':
          this.$confirm('请确认是否删除计划，计划生成的风险评估与管控措施将同时删除？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await sourcesDangerRecognitionPlanApi.callDelete(row.id)
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getList()
              }
            })
            .catch(() => {})
          break
        case 'read':
          this.FormData = this.$options.data().FormData
          this.getPlanDetail(operation, row.id)
          break
        case 'update':
          this.FormData = this.$options.data().FormData
          this.getPlanDetail(operation, row.id)
          break
        case 'publish':
          this.$confirm('是否确认发布？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await sourcesDangerRecognitionPlanApi.publishPlan({
                palanId: row.id,
              })
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '发布成功',
                  type: 'success',
                })
                this.getList()
              }
            })
            .catch(() => {})
          break
        case 'refreshPublish':
          this.FormData = this.$options.data().FormData
          this.getPlanDetail(operation, row.id)
          break
        default:
          break
      }
    },
    // 获取辨识计划详情
    async getPlanDetail(operation, rowId) {
      // 获取计划辨识详情
      const [err, res] = await sourcesDangerRecognitionPlanApi.get(rowId)
      if (!err) {
        const [planErr, planRes] = await sourcesDangerRecognitionPlanTaskApi.pagedListQuery({
          sourcesDangerRecognitionPlanId: rowId,
          skipCount: 0,
          maxResultCount: 999,
        })
        if (!planErr) {
          const {
            id,
            publishStatus,
            recognitionPlanName,
            recognitionPlanTopic,
            planTimeStart,
            planTimeEnd,
            planHeadControlId,
            analyzeEvaluationType,
          } = res
          this.FormData = {
            ...this.FormData,
            id,
            publishStatus,
            recognitionPlanName,
            recognitionPlanTopic,
            planTimeStart,
            planTimeEnd,
            planHeadControlId,
            analyzeEvaluationType,
            sourcesDangerRecognitionPlanTaskDtos: planRes.items,
          }
          if (planTimeStart && planTimeEnd) {
            this.FormData.dateArr = [planTimeStart, planTimeEnd]
          } else {
            this.FormData.dateArr = []
          }
          // 重新发布初始化时间
          if (operation === 'refreshPublish') {
            this.FormData.planTimeEnd = ''
          }
          this.initDialog(operation)
        }
      }
    },
    // 弹窗初始化操作
    initDialog(operation) {
      this.formDialog = true
      this.formProps.pageType = operation
      if (operation === 'create') {
        this.checkComp('CREATE')
      } else if (operation) {
        this.checkComp('UPDATE')
      } else {
        this.checkComp('READ')
      }
    },
    handleSelection(values) {
      this.selectionData = values.map((item) => {
        return item.id
      })
    },
    // 搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.getList()
    },
    // 页码改变
    tableSizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getList()
    },
    // 页数改变
    tableCurrentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getList()
    },
    // 获取辨识计划列表
    async getList() {
      this.selectionData = []
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
        ...this.searchData,
      }
      this.tableLoading = true
      const [err, res] = await sourcesDangerRecognitionPlanApi.pagedListQuery(data)
      if (!err) {
        this.dataList = res.items
        this.totalCount = res.totalCount
      }
      this.tableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
